// extracted by mini-css-extract-plugin
export default {"propertyRelationshipDetails":"PropertyRelationshipDetails_propertyRelationshipDetails__KNmjY"};